package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.domain.model.DevicePlatform
import com.iptvplayer.shared.presentation.viewmodel.DeviceViewModel
import com.iptvplayer.web.ui.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun DevicesScreen(vm: DeviceViewModel, onBack: () -> Unit) {
    val state by vm.state.collectAsState()
    var editingId by remember { mutableStateOf<String?>(null) }
    var editName by remember { mutableStateOf("") }

    PageContainer {
        Div(attrs = { style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); property("gap", "12px"); property("margin-bottom", "8px") } }) {
            GhostButton("← Back") { onBack() }
            H2(attrs = { style { property("margin", "0") } }) { Text("Devices") }
        }
        ErrorText(state.error)

        if (state.isLoading && state.devices.isEmpty()) {
            Spinner()
        } else if (state.devices.isEmpty()) {
            EmptyState("No devices yet. Sign in on your phone or TV and they'll show up here.")
        } else {
            state.devices.forEach { d ->
                if (editingId == d.id) {
                    Div(attrs = { style { cardStyle(); property("padding", "14px"); property("margin-bottom", "10px") } }) {
                        Field("Device name", editName, "name") { editName = it }
                        Div(attrs = { style { display(DisplayStyle.Flex); property("gap", "10px") } }) {
                            PrimaryButton("Save", enabled = editName.isNotBlank(), fullWidth = false) {
                                vm.renameDevice(d.id, editName.trim()); editingId = null
                            }
                            GhostButton("Cancel") { editingId = null }
                        }
                    }
                } else {
                    val status = if (d.isOnline) "● online" else "offline"
                    RowItem(d.name, null, "${platformLabel(d.platform)} · $status", onClick = {}) {
                        GhostButton("Rename") { editingId = d.id; editName = d.name }
                        GhostButton("Remove") { vm.removeDevice(d.id) }
                    }
                }
            }
        }
    }
}

private fun platformLabel(p: DevicePlatform): String = when (p) {
    DevicePlatform.ANDROID_MOBILE -> "Android"
    DevicePlatform.ANDROID_TV -> "Android TV"
    DevicePlatform.IOS -> "iOS"
    DevicePlatform.WEB -> "Web"
}
